export default "__VITE_PUBLIC_ASSET__4d7e0bbb__"